import * as React from 'react'

interface ValidateMessage {
  message: string
  classAdd?: string
}

const ValidateMessage: React.FC<ValidateMessage> = ({ message, classAdd = '' }) => {
  return (
    <>
      <div style={{ whiteSpace: 'pre-wrap' }} className={'error-block text-danger d-block ' + classAdd}>
        {message}
      </div>
    </>
  )
}

export default ValidateMessage
